import useSWR, { SWRResponse } from 'swr';
import { consignmentService } from 'services';
import { ConsignmentDetails } from 'types';
import { swrKeys } from 'helpers';

export function useConsignmentsDetails(
  consignmentCode: string | undefined
): SWRResponse<ConsignmentDetails, any> {
  const code = consignmentCode || '';

  const result = useSWR(
    consignmentCode
      ? swrKeys.consignmentDetails({ consignmentCode: code })
      : null,
    () => consignmentService.getDetails(code),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
    }
  );

  return result;
}
